"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const set_value_1 = __importDefault(require("set-value"));
const strind_1 = __importDefault(require("strind"));
function formatFuseJs(results) {
    const matched = [];
    results.forEach(({ item, matches }, index) => {
        matched.push(Object.assign({}, item));
        matches.forEach(({ indices, key, value }) => {
            const output = (0, strind_1.default)(value, indices, (data) => ({
                text: data.chars,
                matches: data.matches,
            }));
            const formattedResult = output.matched;
            const match = matched[index];
            if (key.split(".").length > 1) {
                (0, set_value_1.default)(match, key, formattedResult);
            }
            else {
                match[key] = formattedResult;
            }
        });
    });
    return matched;
}
exports.default = formatFuseJs;
